/**
 * 系统管理  系统环境变量
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="modt-box">更新快递参数</div>
    <el-col :span="10"> </el-col>
    <el-col :span="18">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="链接" prop="url">
          <el-input size="small" v-model="form.c"></el-input>
        </el-form-item>
        <el-form-item label="Token" prop="token">
          <el-input size="small" v-model="form.k"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="addPoster('form')">保存</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </div>
</template>

<script>
import axios from 'axios';
import jsonpAdapter from 'axios-jsonp';
import { frushKDtokrn,getKDtokrn} from '../../api/userMG'
export default {
  data() {

    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      datass:[],
      c: '添加',
      form: {
        t: '',
        c: '',
        k: ''
      },
      // rules表单验证
      rules: {
        c: [
          { required: true, message: '请输入链接', trigger: 'blur' }
        ],
        k: [
          { required: true, message: '请输入token', trigger: 'blur' }
        ],
      },
      listData: []//用户数据
    }
  },
  created() {
      getKDtokrn().then(res => {
        if (res.state == 200) {
          var datass=res.data.split("——")
          document.cookie = datass[1];
          window.open("https://alayn.baidu.com/express/appdetail/pc_express?"+datass[0]+"770222274525719", '_blank')
          setTimeout(res=>{
            window.open("https://www.baidu.com/s?ie=utf-8&f=8&rsv_bp=1&rsv_idx=1&tn=baidu&wd=yt7489710139589", '_blank')
          },2000)

          // axios.get(
          //   "https://alayn.baidu.com/express/appdetail/pc_express?"+datass[0]+"770222274525719",
          //   {
          //     cookie:datass[1],
          //     responseType: 'text',
          //     withCredentials:true
          //   }).then(response => {
          //     console.log(111);
          //   }).catch(error => {
          //     console.error('Error fetching data:', error);
          // });
        }
      })
  },

  methods: {
    addPoster(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          this.$confirm('确定要提交吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(()=>{
            this.loading = true
            var urlstr=this.form.c.split("&")
            this.form.c=urlstr[0].split("?")[1]+"&"+urlstr[1]+"&"+urlstr[2]+"&"+urlstr[5]+"&nu="
            frushKDtokrn(this.form).then(res => {
              if (res.state == 200) {
                this.$message({
                  type: 'success',
                  message: '提交成功!'
                })
                this.loading = false
              }
            })
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/system/kuaidiToken.vue